module.exports = __webpack_public_path__ + "media/madeca-large.aeefa689.mp4";